export default {
    // checkSignUp: (data) => window.axios.post('registration',data)
    checkSignUp: (data) => window.axios.post('customer/registration', data)
}